
import clsx from 'clsx';
import styles from './Tab.module.scss';
import { ReactNode } from 'react';

interface TabPanelProps {
  children?: ReactNode;
  id: string;
  value?: string;
  onScroll?: (e: any) => void;
  className?: any;
}

export const TabPanel = ({ children, id, value, onScroll, className }: TabPanelProps) => {
  const isActive = value === id;
  return (
    <div role="tabpanel" id={id} className={clsx(styles.tab_panel, className, { [styles.active]: isActive })} onScroll={onScroll}>
      {isActive ? children : null}
    </div>
  );
};
